var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoodPrice = function SvgGoodPrice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#good-price_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#good-price_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M27.894 6.691a.54.54 0 0 1 .624.508l.725 15.775a.54.54 0 0 1-.521.563l-17.465.552a.54.54 0 0 1-.556-.54V9.984c0-.262.19-.487.45-.53l7.373-1.247.001.001 9.369-1.516Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#good-price_svg__c)",
    fillOpacity: 0.15,
    d: "M27.894 6.691a.54.54 0 0 1 .624.508l.725 15.775a.54.54 0 0 1-.521.563l-17.465.552a.54.54 0 0 1-.556-.54V9.984c0-.262.19-.487.45-.53l7.373-1.247.001.001 9.369-1.516Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.606,
    d: "M27.894 6.691a.54.54 0 0 1 .624.508l.725 15.775a.54.54 0 0 1-.521.563l-17.465.552a.54.54 0 0 1-.556-.54V9.984c0-.262.19-.487.45-.53l7.373-1.247.001.001 9.369-1.516Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.606,
    d: "M30.192 9.83a.54.54 0 0 1 .537.54v14.823a.54.54 0 0 1-.54.538H11.24a.54.54 0 0 1-.539-.538V10.36c0-.296.24-.536.536-.538l9.477-.046z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m21.34 18.239.667 2.384h.937l.607-2.384h1.054v-.75h-.864l.58-2.278h-.72l-.567 2.279H21.93l-.566-2.28h-.953l-.566 2.28H18.74l-.567-2.28h-.72l.58 2.28h-.87v.749h1.06l.607 2.384h.936l.668-2.384h.905Zm-.21-.75-.243-.867-.243.868zm.986.75.366 1.473.366-1.473zm-2.457 0-.366 1.473-.366-1.473z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.606,
    d: "M29.82 17.4a.54.54 0 0 1 .535.54v2.344a.54.54 0 0 1-.539.54h-3.603a1.715 1.715 0 0 1-.007-3.43l1.22-.004 2.393.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.507,
    d: "M30.183 16.552c1.517 0 2.906.253 3.944.675.518.21.959.466 1.284.762.278.253.48.546.564.871q.04.061.043.14v3.95c0 .108-.027.21-.07.299q-.008.027-.02.052.03.075.048.15.04.06.042.138v3.95a.7.7 0 0 1-.07.298l-.02.053q.027.072.047.147.041.061.043.14v3.95c0 .103-.025.2-.065.287-.11.35-.36.66-.692.924-.34.27-.78.504-1.29.696-1.018.385-2.345.614-3.788.614-1.444 0-2.77-.23-3.79-.614-.509-.192-.949-.426-1.288-.696-.331-.263-.579-.57-.69-.917a.7.7 0 0 1-.067-.294v-3.95q0-.079.042-.14.018-.076.046-.148l-.016-.041-.03-.072a.7.7 0 0 1-.042-.237v-3.95a.25.25 0 0 1 .046-.144q.018-.072.044-.141l-.018-.044-.03-.073a.7.7 0 0 1-.042-.237V19q.002-.079.044-.14c.087-.343.306-.65.608-.912.33-.287.771-.536 1.287-.741 1.032-.41 2.402-.655 3.896-.655Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.507,
    d: "M31.198 16.552c1.518 0 2.907.253 3.945.675.518.21.959.466 1.284.762.278.253.48.546.563.871a.25.25 0 0 1 .043.14v3.95c0 .108-.027.21-.07.299q-.008.027-.019.052.028.075.047.15.04.06.042.138v3.95a.7.7 0 0 1-.07.298q-.008.026-.02.053.028.072.047.147a.25.25 0 0 1 .043.14v3.95c0 .103-.025.2-.064.287-.111.35-.36.66-.693.924-.34.27-.78.504-1.289.696-1.018.385-2.345.614-3.789.614s-2.77-.23-3.789-.614c-.51-.192-.95-.426-1.289-.696-.33-.263-.578-.57-.69-.917a.7.7 0 0 1-.067-.294v-3.95q.002-.079.042-.14.02-.076.047-.148l-.017-.041-.03-.072a.7.7 0 0 1-.042-.237v-3.95q.002-.082.046-.144.019-.072.044-.141l-.017-.044-.03-.073a.7.7 0 0 1-.043-.237V19q.002-.079.044-.14c.088-.343.307-.65.609-.912.33-.287.77-.536 1.287-.741 1.032-.41 2.401-.655 3.895-.655Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35.878 32.043q-.001.106-.047.195c-.356 1.162-2.724 2.06-5.591 2.06s-5.236-.898-5.592-2.06a.44.44 0 0 1-.046-.195v-3.929h.016q-.016.09-.016.182c0 1.306 2.524 2.364 5.638 2.364s5.638-1.058 5.638-2.364a1 1 0 0 0-.016-.182h.016z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.24,
    cy: 28.297,
    fill: "#000",
    rx: 5.638,
    ry: 2.364
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35.878 27.48q-.001.106-.047.196c-.356 1.162-2.724 2.06-5.591 2.06s-5.236-.898-5.592-2.06a.44.44 0 0 1-.046-.196v-3.928h.016q-.016.09-.016.182c0 1.305 2.524 2.364 5.638 2.364s5.638-1.058 5.638-2.364q0-.092-.016-.182h.016z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.24,
    cy: 23.733,
    fill: "#000",
    rx: 5.638,
    ry: 2.364
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35.878 22.917q-.001.106-.047.195c-.356 1.162-2.724 2.06-5.591 2.06s-5.236-.898-5.592-2.06a.43.43 0 0 1-.046-.195v-3.929h.016a1 1 0 0 0-.016.182c0 1.306 2.524 2.365 5.638 2.365s5.638-1.059 5.638-2.365a1 1 0 0 0-.016-.182h.016z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.507,
    d: "M30.24 16.552c1.582 0 3.026.269 4.084.713.529.221.973.491 1.29.804.316.315.518.687.518 1.1 0 .415-.202.787-.519 1.101-.316.314-.76.585-1.289.806-1.058.444-2.502.712-4.084.712s-3.026-.268-4.085-.712c-.528-.221-.973-.492-1.289-.806-.317-.314-.518-.686-.518-1.1s.201-.787.518-1.1c.316-.314.76-.584 1.29-.805 1.058-.444 2.502-.713 4.084-.713Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.507,
    d: "M5.456 24.351c.67-.33 2.613-1.015 2.816-3.428.172-2.058-.172-3.939 1.499-3.883s1.6 1.255 1.554 2.615l-.091 2.72 3.87.031c.559-.032 1.902.054 1.995 1.048.14 1.5-2.348 1.108-2.706 1.197.3.161 2.871-.447 2.815 1.236-.029.858-.937 1.042-1.773 1.06.988.124 2.154.53 1.489 1.735-.188.34-1.058.443-1.718.472 2.59.185 2.05 2.514-1.61 2.22-3.986-.321-7.5-.263-7.973-.642-.593-.473-.375-.186-.334-1.395z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.507,
    d: "M4.737 24.329c.67-.33 2.613-1.015 2.816-3.429.173-2.058-.172-3.938 1.5-3.882 1.67.056 1.599 1.254 1.553 2.614l-.091 2.72 3.87.032c.56-.032 1.903.053 1.995 1.047.14 1.5-2.347 1.109-2.705 1.198.299.16 2.87-.447 2.814 1.236-.029.858-.937 1.042-1.773 1.06.988.123 2.154.53 1.489 1.734-.188.34-1.058.444-1.718.472 2.59.186 2.05 2.514-1.609 2.22-3.987-.32-7.5-.262-7.974-.641-.593-.474-.375-.186-.334-1.395z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.368,
    height: 8.118,
    x: 2.766,
    y: 23.747,
    fill: "#000",
    rx: 0.676,
    transform: "rotate(-3.48 2.766 23.747)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "good-price_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "good-price_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.281 6.078h47.692v33.486H2.281z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "good-price_svg__c",
    x1: 19.992,
    x2: 19.869,
    y1: 6.242,
    y2: 12.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
};
export default SvgGoodPrice;